import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import routes from "./routes";
import {BrowserRouter} from "react-router-dom";
import './App.scss';
import './Blockly.scss';
import './styles/theme/dark-iconfont.scss';
import './styles/theme/light-iconfont.scss';
import './styles/theme/themes.css';

export default function App ({ store }) {
    return (
        <Provider store = { store }>
            <BrowserRouter>
                <div>
                    { routes }
                </div>
            </BrowserRouter>
        </Provider>
    );
}

App.propTypes = {
    store: PropTypes.object.isRequired,
};